<template>
<m-pageframe
    title="All Tests"
>
<v-container>
    <v-text-field
        autofocus
        prepend-icon="mdi-magnify"
        v-model="full_text"
        @keydown.enter="onRunFirst"
        autocomplete="off"
    />

<div
    style="text-align: center"
>
    <div
        v-for="(test, key) in tests" 
        :key="key"
            class="admin_button"
            v-show="inSearch(test)"
            v-on:click="gotoTest(test)"
    >
        <div
            style="flex-grow: 1; font-weight: bold;"
        >
            {{test.name}}
        </div>
    </div>

</div>
</v-container>
</m-pageframe>
</template>

<script>
export default {
    data() {
        return {
            full_text: null,

            tests: [
                { name: 'Rest API Environment', 'page_name' : 'test-environment' },
                { name: 'API calls and error handling', 'page_name' : 'test-axios' },
                { name: 'Revoke Authentication', 'page_name' : 'test-revoke-auth' },
                { name: 'Input Controls', page_name: 'test-input'},
                { name: 'Test Global Controls', page_name: 'test-global-controls' },
                { name: 'Test Attachments', page_name: 'test-attachments' },
                { name: 'Test Eula Signatures', page_name: 'test-eula-signature' },
                { name: 'Test Showdown', page_name:'test-showdown' },
                { name: 'Test Tock Reservation', page_name: 'test-tock-reservation' },
                { name: 'Test Table', page_name: 'test-table' },
            ]
        }
    },

    methods: {
        gotoTest(test) 
        {
            if ( test.page_name == 'test-params' )
            {
                this.$router.push({'name': test.page_name, params: {'my_param': '#PINOT'} });
            }
            else
            {
                this.$router.push({'name': test.page_name});
            }
        },

        inSearch(page)
        {
            if ( this.full_text == null ) return true;
            return page.name.toLowerCase().includes(this.full_text.toLowerCase());
        },

        onRunFirst()
        {
            for ( let i = 0; i < this.admin_pages.length; i++ )
            {
                let page = this.admin_pages[i];
                if ( this.inSearch(page) ) 
                {
                    this.gotoPage(page);
                    return;
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>

.admin_button
{
    border: 1px solid rgba(0,0,0,0.1); 
    padding-left: 15px; 
    padding-right: 15px; 
    padding-top: 20px; 
    padding-bottom: 20px; 
    border-radius: 5px; 
    margin-bottom: 7px; 
    text-align: left; 
    display: flex; cursor: pointer;
}

.admin_button:hover
{
    text-decoration: underline;
}

</style>